export const JOURNAL_VIEW_SEND_ERROR = 'Ошибка при отправке просмотра статьи:';
export const JOURNAL_SEARCH_ERROR = 'Ошибка при поиске по журналу:';
